import { Typography } from '@/components/UI/Typography'
import { IconChevronRight, IconInfoCircle } from '@tabler/icons-react'
import Link from 'next/link'
import React, { memo } from 'react'

type NewsListType = {
  link: string
  time: string
  text: string
  id: string
  /** 既読かどうか。false（未読）のときタイトルを太字で表示する（#2973） */
  isRead: boolean
}

export const NewsList = memo(({ link, time, text, id, isRead }: NewsListType) => {
  return (
    <Link
      href={{
        pathname: link,
        query: { id },
      }}
      className="flex h-[72px] items-center gap-[18px] border-b border-[#cbcbce] px-4"
    >
      <IconInfoCircle size={24} className="shrink-0 text-[#cbcbce]" />
      <div className="min-w-0 flex-1">
        {/* 未読: subtitle1（16px / Bold）、既読: body4（16px / Regular）。どちらも line-height 24px で行高は変わらない */}
        <Typography variant={isRead ? 'body4' : 'subtitle1'} component="span" className="block truncate">
          {text}
        </Typography>
        <Typography variant="caption1" component="span" className="block truncate" c={'system.6'}>
          {time}
        </Typography>
      </div>
      <IconChevronRight size={24} className="shrink-0 text-[#cbcbce]" />
    </Link>
  )
})
